<!--
 * @Author: daidai
 * @Date: 2022-03-04 09:23:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-05-07 11:05:02
 * @FilePath: \web-pc\src\pages\big-screen\view\indexs\index.vue
-->
<template>
  <div class="contents">
    <!-- <div>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button @click="stopAlertSound">停止播放告警声音</button>
    <div class="item">实时监测</div>
          <button @click="startAlertSound">开始循环播放告警声音</button>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button @click="stopAlertSound">停止播放告警声音</button>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    
    </div> -->
     <!-- <div v-if="visible" :class="['notification alert-mask', type]" @click="handleClick">
        <AlertBox/>
     </div> -->
    
      <!-- 蒙版背景 -->
    <div v-if="visible" :class="['alert-mask ', type]" @click="handleClick">
      <!-- 弹窗主体 -->
      <div class="alert-modal">
        <!-- 红色头部 -->
        <div class="alert-header">
          <div class="alert-icon">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path fill="white" d="M12 2L1 21h22L12 2zm0 5l7 12H5l7-12z"/>
              <rect fill="white" x="11" y="9" width="2" height="6" rx="1"/>
              <circle fill="white" cx="12" cy="18" r="1.5"/>
            </svg>
          </div>
          <div class="alert-title">冷链设备告警信息</div>
          <div class="close-btn" @click="handleClick">×</div>
        </div>

        <!-- 告警内容 -->
        <div class="alert-body">
          <div class="alert-item">
            <div class="item-label">告警单位</div>
            <div class="item-value"><span>{{ tmpMessage.deptName }}</span></div>
          </div>
          <div class="alert-item">
            <div class="item-label">设备名称</div>
            <div class="item-value">{{ tmpMessage.deviceName }}</div>
          </div>
          <div class="alert-item">
            <div class="item-label">设备SN号</div>
            <div class="item-value">{{ tmpMessage.sn }}</div>
          </div>

          <!-- <div class="alert-item">
            <div class="item-label">第一次报警时间</div>
            <div class="item-value">{{ tmpMessage.create_time }}</div>
          </div> -->

          <div class="alert-item">
            <div class="item-label">异常报警时间</div>
            <div class="item-value">{{ tmpMessage.warnTime }}</div>
          </div>

          <div class="alert-item">
            <div class="item-label">异常情况</div>
            <div class="item-value"><span>温度异常（{{ tmpMessage.value }}{{ tmpMessage.unit }}）</span></div>
          </div>
        </div> 

        <!-- 操作按钮 -->
        <!-- <div class="alert-footer">
          <button class="action-btn ignore">忽略</button>
          <button class="action-btn confirm" :style="{ backgroundColor: alertTypeColor }">
            处理告警
          </button>
        </div> -->
      </div>
    </div>



    <div>
      <!-- 一个隐藏的音频元素 -->
      <audio id="audio" ref="audio" src="./../../assets/music/warn01.mp3" controls="controls" style="z-index: 999999;display: none; margin-left: 600px" />
    </div>









    <!-- <alert-box ref="alertBox"></alert-box> -->
    <div class="contetn_left">
      <div class="pagetab">
        <!-- <div class="item">实时监测</div> -->
        
      </div>
      <!-- <ItemWrap class="contetn_left-top contetn_lr-item" title="设备打卡率">
        <LeftTop/>
    
      </ItemWrap> -->
      <ItemWrap class="contetn_left-center contetn_lr-item" 
      title="全县冷链设备类型统计" style="height : 450px;">
        <LeftCenter />
      </ItemWrap>
      <ItemWrap
        class="contetn_left-bottom contetn_lr-item"
        title="本单位冷链设备温度曲线图"
        style="height : 585px;"
      >
        <RightTop />
      </ItemWrap>
    </div>
   <div class="contetn_center">
      <CenterMap class="contetn_center_top" />
      <!-- <ItemWrap class="contetn_center-bottom" title="安装计划">
        <CenterBottom />
      </ItemWrap> -->
    </div>
    <div class="contetn_right_top">
      <ItemWrap class="contetn_left-top contetn_lr_right_top-item" 
      title="冷链设备温度打卡率" style="height: 150px;">
        <LeftTop/>
      </ItemWrap>

      <ItemWrap
        class="contetn_left-bottom contetn_lr_right_bottom-item"
        title="全县冷链设备温度打卡情况" style="height: 845px;"
      >
      <LeftBottom />
      </ItemWrap>
      <!-- <ItemWrap
        class="contetn_left-bottom contetn_lr-item"
        title="报警排名(TOP8)"
        style="padding: 0 10px 16px 10px"
      >
        <RightCenter />
      </ItemWrap>
      <ItemWrap
        class="contetn_left-bottom contetn_lr-item"
        title="数据统计图 "
      >
        <RightBottom />
      </ItemWrap> -->
    </div>
  </div>
</template>
<script>
import LeftTop from './left-top.vue'
import LeftCenter from "./left-center.vue";
import LeftBottom from "./left-bottom.vue";
import CenterMap from "./center-map.vue";
import CenterBottom from "./center-bottom.vue";
import RightTop from "./right-top.vue";
import RightCenter from "./right-center.vue";
import RightBottom from "./right-bottom.vue";
import { statMapEquimentWarnData } from 'api/modules/largescreen';
import AlertBox from './AlertBox.vue';

export default {
  props: {
    // position: {
    //   type: String,
    //   default: 'top-center'
    // },
      // tmpMessage: {
      //   type: Object,
      //   required: true
      // },
      // type: {
      //   type: String,
      //   default: 'info'
      // }
  },
  components: {
    LeftTop,
    LeftCenter,
    LeftBottom,
    CenterMap,
    RightTop,
    RightCenter,
    RightBottom,
    CenterBottom,
    AlertBox,
    
  },
  data() {
    return {
      tmpMessage:{},
      alertSound: null,
      // localAudioSrc:require('@/assets/music/warn01.mp3'), // 替换为你的音频文件路径
      timer: null,
      pollInterval: 5000, // 5秒轮询一次
      showModal: false,
      visible: false,
      queue: [],
    };
  },
      //轮询
   switper() {
     if (this.timer) {
       return
    }
     let looper = (a) => {
       this.fetchAlerts()
     };
     console.log("轮询："+looper);
     this.timer = setInterval(looper, 20);
   },
  filters: {
    numsFilter(msg) {
      return msg || 0;
    },
  },
  created() {
  },

  mounted() {
      this.startPolling();  // 启动定时轮询
  },
  computed: {
  },
  beforeUnmount() {
     this.stopPolling();  // 停止轮询
  },
  methods: {
    fetchAlerts() {
       statMapEquimentWarnData().then(res => {
          console.log("告警数据更新：", res);
          var dataList = res.data.dataList;
          // 触发UI更新或告警逻辑
           if (dataList && dataList.length > 0) { // 假设返回一个告警数组
            const alert = dataList[0]; // 获取第一个告警作为示例，可以根据需求调整逻辑（例如轮询）
            var aSize = dataList.length;
            for (var i = 0; i < aSize; i++) {
                  var resData = dataList[i];
                  // this.show(resData, "1");
                  this.queue.push(resData);
            }
           
            if (!this.visible) {
              this.processQueue();
            }
          } else { // 没有新的告警，可以设置定时器再次检查或者不做任何操作。例如：setTimeout(this.fetchAlerts, 5000); // 每5秒检查一次。根据需求调整。
                    // 没有告警数据，60秒后再次轮询
                   setTimeout(() => {
                     this.fetchAlerts();
                   }, 60000);
          }
        })
        .catch(error => {
          console.error("告警数据获取失败：", error);
           this.stopAlertSound();
        });
    },
    show(message, type) {
      // this.queue.push({ message, type });
      // if (!this.visible) {
      //   this.processQueue();
      // }
    },
    processQueue() {
      const notification = this.queue.shift();
      let dpShowAreaId = localStorage.getItem("dpShowAreaId");
      if (notification) {
       //关键修复：设置 visible = true 显示告警框
        this.tmpMessage = notification;  // 设置告警数据
        this.visible = true;
          setTimeout(() => {
            this.visible = false;
            this.processQueue();  // 继续处理下一条
          }, 5000);  // 弹框显示5秒
      }else{
            // 队列为空，60秒后再次轮询
            setTimeout(() => {
                this.fetchAlerts();
              }, 60000);
      }
    },
    handleClick() {
      this.visible = false;
      this.queue = [];
    },

     // ✅ 添加定时轮询方法
      startPolling() {
        this.fetchAlerts();
        // 每5秒轮询一次（根据需求调整）
        this.timer = setInterval(() => {
          if (!this.visible) {  // 只有在告警框关闭时才请求新数据
            this.fetchAlerts();
          }
        }, 5000);
      },

      stopPolling() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
  },
 
};
</script>
<style lang="scss" scoped>

// 内容
.contents {
  .contetn_left,
  .contetn_right {
    width: 630px;
    box-sizing: border-box;
    // padding: 16px 0;
  }

  .contetn_center {
    width: 720px;
  }

  //左右两侧 三个块
  .contetn_lr-item {
    height: 498px;
  }

  .contetn_right_top {
  height:   1000px;
    width: 540px;
    box-sizing: border-box;
    // padding: 16px 0;
  }

  .contetn_lr_right_top-item {
    height: 150px;
  }

  .contetn_lr_right_bottom-item{
      height: 810px;
  }

  .contetn_center_top {
    width: 100%;
  }

  // 中间
  .contetn_center {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .contetn_center-bottom {
    height: 315px;
  }

  //左边 右边 结构一样
  .contetn_left,
  .contetn_right {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: relative;
  }
  .contetn_left {
     //margin-top: -18px;
  }
}


@keyframes rotating {
    0% {
        -webkit-transform: rotate(0) scale(1);
        transform: rotate(0) scale(1);
    }
    50% {
        -webkit-transform: rotate(180deg) scale(1.1);
        transform: rotate(180deg) scale(1.1);
    }
    100% {
        -webkit-transform: rotate(360deg) scale(1);
        transform: rotate(360deg) scale(1);
    }
}





.shadow {
    position: absolute;
    top: 50%;
    left: 50%;
}
.notification {
  position: fixed;
  width: 82%;
  height: 60%;
  background: #FF9800;
  top: 10%;
  left: 10%;
  // padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  color: white;
  font-size: 14px;
  z-index: 1000;
}
.notification p{
  font-size: 24px;
  line-height: 80px;
  color: #fff;
  text-align: center;
}

.info {
  background-color: #4CAF50;
}

.warning {
  background-color: #FF9800;
}

.error {
  background-color: #F44336;
}


















// 弹窗尺寸样式
/* 蒙版样式 */
.alert-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

/* 弹窗主体 */
.alert-modal {
  background-color: white;
  overflow: hidden;
  animation: modalEnter 0.3s ease-out;
  position: fixed;
  width: 82%;
  height: 48%;
  // background: #FF9800;
  top: 25%;
  left: 10%;
  // padding: 10px;
  // border-radius: 5px;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  color: white;
  font-size: 14px;
}

@keyframes modalEnter {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 弹窗头部 */
.alert-header {
  padding: 16px 24px;
  display: flex;
  align-items: center;
  color: white;
  font-weight: 600;
  position: relative;
  background: #F44336;
}

.alert-icon {
  margin-right: 12px;
  display: flex;
  align-items: center;
}

.alert-title {
    font-size: 34px;
    flex: 1;
    font-weight: 900;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  padding: 0 8px;
  line-height: 1;
  transition: transform 0.2s;
}

.close-btn:hover {
  transform: scale(1.2);
}

/* 告警内容 */
.alert-body {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;
}

.alert-item {
  display: flex;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 36px;
  text-align: center;
}

.alert-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.item-label {
    text-align: right;
    font-size: 36px;
    padding-right: 60px;
    width: 40%;
    color: #666;
}

.item-value {
  flex: 1;
  color: #333;
  font-weight: 500;
  text-align: left;
  padding-left: 50px;
}

.item-value span {
  color: #F44336;
  font-weight: 600;
}

/* 底部按钮 */
.alert-footer {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.action-btn {
  padding: 8px 24px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.action-btn.ignore {
  background: #f5f5f5;
  color: #666;
}

.action-btn.ignore:hover {
  background: #eaeaea;
}

.action-btn.confirm {
  color: white;
}

.action-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}





</style>
